// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"NewslineItem_ProseMirror__307d4","item":"NewslineItem_item__F0_GO","item_alone":"NewslineItem_item_alone__3fAYj","item__title":"NewslineItem_item__title__3KOVx"};